module.exports = __webpack_public_path__ + "img/product-desc4.26247f2e.png";